<template>
    <div>
        <attachment-uploader v-model="item.image" :canUpload="true" label="Immagine"></attachment-uploader>

        <div class="row mb-2">
            <div class="col-6">
                <label class="form-label small">Larghezza (cm)</label>
                <input class="form-control form-control-sm" type="number" step="0.01" min="0" v-model.number="tempWidth" />
            </div>
            <div class="col-6">
                <label class="form-label small">Altezza (cm)</label>
                <input class="form-control form-control-sm" type="number" step="0.01" min="0" v-model.number="tempHeight" />
            </div>
        </div>

        <div class="mb-2" v-if="item.image && item.image.publicUrl">
            <button class="btn btn-sm btn-outline-secondary w-100 mb-1" @click="fitToImageSize">
                Adatta alle dimensioni originali
            </button>
            <button class="btn btn-sm btn-outline-secondary w-100" @click="fitToProportions">
                Adatta mantenendo proporzioni
            </button>
        </div>

        <div class="mb-2">
            <label class="form-label small">Adattamento</label>
            <select class="form-select form-select-sm" v-model="item.objectFit">
                <option value="contain">Contain (mantieni proporzioni)</option>
                <option value="cover">Cover (riempi area)</option>
                <option value="fill">Fill (distorci)</option>
                <option value="scale-down">Scale Down (riduci se necessario)</option>
            </select>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';
import { pxToCm, cmToPx } from '@/utils/units';

@Options({})
export default class ImageComponentEditor extends Vue {
    @Prop() item: OM.ImageComponent;

    localTempWidth: number = null;
    localTempHeight: number = null;

    @Watch('item')
    onItemChange() {
        this.localTempWidth = null;
        this.localTempHeight = null;
    }

    get tempWidth() { return this.localTempWidth ?? pxToCm(this.item.width); }
    set tempWidth(value: number) { this.localTempWidth = value; this.item.width = cmToPx(value); }

    get tempHeight() { return this.localTempHeight ?? pxToCm(this.item.height); }
    set tempHeight(value: number) { this.localTempHeight = value; this.item.height = cmToPx(value); }

    fitToImageSize() {
        if (!this.item.image || !this.item.image.publicUrl) {
            return;
        }

        const img = new Image();
        img.onload = () => {
            this.item.width = img.naturalWidth;
            this.item.height = img.naturalHeight;
        };
        img.src = this.item.image.publicUrl;
    }

    fitToProportions() {
        if (!this.item.image || !this.item.image.publicUrl) {
            return;
        }

        const img = new Image();
        img.onload = () => {
            const aspectRatio = img.naturalWidth / img.naturalHeight;

            // Se l'immagine è più larga che alta (landscape)
            if (img.naturalWidth >= img.naturalHeight) {
                // Mantieni la larghezza attuale e calcola l'altezza
                const currentWidth = this.item.width || 150;
                this.item.width = currentWidth;
                this.item.height = Math.round(currentWidth / aspectRatio);
            } else {
                // Immagine più alta che larga (portrait)
                // Mantieni l'altezza attuale e calcola la larghezza
                const currentHeight = this.item.height || 150;
                this.item.height = currentHeight;
                this.item.width = Math.round(currentHeight * aspectRatio);
            }
        };
        img.src = this.item.image.publicUrl;
    }
}
</script>
